module.exports = __webpack_public_path__ + "img/volleyball_premier.758dd219.svg";